export default class User {
  constructor() {
    this.apps = [];
    this.member_id = null;
    this.cognitoUsername = null;
  }

  init(app) {
    this.apps.push(app);
  }
}

User.ACCESS_NONE = 0;
User.ACCESS_TRIAL = 10;
User.ACCESS_NORMAL = 20;
User.ACCESS_ADMIN = 30;

User.install = (Vue) => {
  Object.defineProperty(Vue.prototype, '$user', {
    get() {
      return this.$root._user;
    },
  });

  Vue.mixin({
    beforeCreate() {
      if (this.$options.user) {
        this._user = this.$options.user;
        this._user.init(this);
      }
    },
  });
};
